// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__12EMF","list":"PatternAutocomplete_list__1EqRj"};